import React, {useEffect, useState} from "react";
import NumberFormat from "react-number-format";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {
    datePickerField,
    feeListHead,
    selectDropDownField,
    updateTotalBalance
} from "../../../../helpers/utils/OrderDetailUtils";


interface Fee {
    type: string | null;
    amount: number | null;
    currentMonth: number | null;
    nextMonth: number | null;
    periodStart: string | null;
    periodEnd: string | null;
    frequency: string | null;
    note: string | null;
    paid: number | null;
    associationFee: boolean;
}

interface Account {
    taxDataSource: string;
    fees: Fee[];
    amountTotal?: number | null;
    paidTotal?: number | null;
    currentMonthTotal?: number | null;
    nextMonthTotal?: number | null;

    [key: string]: any;
}

interface FeeListSectionProps {
    curAccount: any;
    showAccount: number;
    setCertificate: React.Dispatch<React.SetStateAction<any>>;
    accounts: Account[];
    setAccounts: React.Dispatch<React.SetStateAction<Account[]>>;
    isSavedResult: boolean;
    setIsSavedResult: React.Dispatch<React.SetStateAction<boolean>>;
    editable: boolean;
    updatedAccountIndexList: number[];
    setUpdatedAccountIndexList: any;
    certificate: any
}

export function FeeListSection({
                                   curAccount,
                                   showAccount,
                                   certificate,
                                   setCertificate,
                                   isSavedResult,
                                   setIsSavedResult,
                                   editable,
                                   updatedAccountIndexList,
                                   setUpdatedAccountIndexList
                               }: FeeListSectionProps) {

    const {data: enums} = useGetEnumsQuery("");
    const [index, setIndex] = useState<number>(0);
    const [isRemoveFee, setIsRemoveFee] = useState<boolean>(false);
    const [isAddNewFee, setIsAddNewFee] = useState<boolean>(false);

    useEffect(() => {
        if ((isRemoveFee || isAddNewFee)) {
            setUpdatedAccountIndexList((prev:any) => {
                if (!prev.includes(showAccount)) {
                    return [...prev, showAccount]; // return a new array
                }
                return prev; // no change needed
            });
            if (isSavedResult) {
                setIsSavedResult(false);
            }
        }
    }, [isRemoveFee, isAddNewFee]);

    useEffect(() => {
        if (isRemoveFee) {
            curAccount['taxDataSource'] = 'EDITOR';
            curAccount.fees = curAccount.fees.filter((value1: any, p: any) => p !== index);
            if (curAccount.fees.length === 0) {
                curAccount.fees.push({
                    "type": '',
                    "amount": null,
                    "currentMonth": null,
                    "nextMonth": null,
                    "periodStart": null,
                    "periodEnd": null,
                    "frequency": '',
                    "note": null,
                    "paid": null,
                    "associationFee": false
                });
            }
            updateTotalBalance(curAccount, curAccount.fees);
            setCertificate((certificate: any) => {
                return certificate
            });
            setIsRemoveFee(false);
        }

    }, [isRemoveFee]);

    useEffect(() => {
        if (isAddNewFee) {
            curAccount['taxDataSource'] = 'EDITOR';
            curAccount.fees = ([...curAccount.fees, {
                "type": null,
                "amount": null,
                "currentMonth": null,
                "periodStart": null,
                "periodEnd": null,
                "frequency": null,
                "note": null,
                "paid": null,
                "associationFee": false
            }]);
            updateTotalBalance(curAccount, curAccount.fees);
            setCertificate((certificate: any) => {
                return certificate
            });
            setIsAddNewFee(false);
        }
    }, [isAddNewFee]);

    const formatValue = (value: number | null) => {
        if (value === null || value === undefined) return "N/A";
        return value;
    };
    const noteTextAreaField = (
        row: any,
        setIsSavedResult: (val: boolean) => void,
        editable: boolean,
        certificate: any,
        setCertificate: (cert: any) => void,
        showAccount: number
    ) => {
        return (
            <textarea
                className="fee_height h-10 border border-surface-5 form-control"
                placeholder="..."
                value={row["note"]}
                onChange={(e) => {
                    const newValue = e.target.value;

                    const updatedCertificate = { ...certificate };
                    const targetAccount = { ...updatedCertificate.accounts[showAccount] };

                    targetAccount.fees = targetAccount.fees.map((fee: any) => {
                        if (fee === row) {
                            return {...fee, note: newValue};
                        }
                        return fee;
                    });
                    targetAccount.taxDataSource = "EDITOR";

                    updatedCertificate.accounts[showAccount] = targetAccount;
                    setCertificate(updatedCertificate);
                    setIsSavedResult(false);
                }}
                readOnly={!editable}
            />
        );
    };
    const currencyInputField = (
        row: any,
        fieldName: string,
        setIsSavedResult: (val: boolean) => void,
        editable: boolean,
        certificate: any,
        setCertificate: (cert: any) => void,
        showAccount: number,
        updateTotalBalance: (account: any, fees: any[]) => void
    ) => {
        const value = row[fieldName];
        const displayValue = value === null || value === '' ? "N/A" : value;
        const prefix = value !== null && value !== '' ? "$" : '';

        return (
            <NumberFormat
                placeholder="..."
                className={
                    !editable
                        ? "text-center border border-highlight-8 fee_height form-control readonly_bg"
                        : "text-center border border-text-9 fee_height form-control"
                }
                decimalScale={value != null ? 2 : undefined}
                decimalSeparator="."
                fixedDecimalScale
                value={displayValue}
                prefix={prefix}
                thousandSeparator={true}
                onChange={(e: any) => {
                    const updatedValue = e.target.value.replace('$', '').replaceAll(',', '');

                    const updatedCertificate = { ...certificate };
                    const targetAccount = { ...updatedCertificate.accounts[showAccount] };

                    targetAccount.fees = targetAccount.fees.map((fee: any) => {
                        if (fee === row) {
                            return {...fee, [fieldName]: updatedValue};
                        }
                        return fee;
                    });
                    targetAccount.taxDataSource = "EDITOR";

                    updatedCertificate.accounts[showAccount] = targetAccount;
                    setCertificate(updatedCertificate);

                    setUpdatedAccountIndexList((prev: number[]) =>
                        prev.includes(showAccount) ? prev : [...prev, showAccount]
                    );
                    updateTotalBalance(targetAccount, targetAccount.fees);
                    setIsSavedResult(false);
                }}
                readOnly={!editable}
            />
        );
    };




    return (
        <div className="col-md-12 mt-3">
            <div className="  bg-highlight-1 text-text-0 p-2">
                <b>Fee List</b>
            </div>
            <div className="overflow-auto">
                <table className="table-fixed w-full border border-text-4 text-sm">
                    {feeListHead(setIsAddNewFee, editable, curAccount)}
                    <tbody>
                    {curAccount?.fees?.map((row: any, p: any) => (
                        <tr key={p}>
                            <td className="p-2 align-middle text-center whitespace-nowrap">
                                <i
                                    className={`fa fa-trash mt-2 ${
                                        editable ? "text-highlight-1 cursor-pointer" : "text-gray-400"
                                    }`}
                                    onClick={() => {
                                        if (editable) {
                                            setIndex(p);
                                            setIsRemoveFee(true);
                                        }
                                    }}
                                    title="Delete Fee"
                                />
                            </td>

                            <td className="text-center">

                                {selectDropDownField(row, 'type', setIsSavedResult, enums?.["FeeType"], editable, certificate, setCertificate, showAccount, setUpdatedAccountIndexList)}

                            </td>

                            <td className="text-center">
                                {datePickerField(
                                    row,
                                    "periodStart",
                                    setIsSavedResult,
                                    editable,
                                    certificate,
                                    setCertificate,
                                    showAccount,
                                    setUpdatedAccountIndexList
                                )}
                            </td>
                            <td className="text-center ">
                                {datePickerField(
                                    row,
                                    "periodEnd",
                                    setIsSavedResult,
                                    editable,
                                    certificate,
                                    setCertificate,
                                    showAccount,
                                    setUpdatedAccountIndexList
                                )}
                            </td>

                            <td className="text-center">
                                {currencyInputField(row, "amount", setIsSavedResult, editable, certificate, setCertificate, showAccount, updateTotalBalance)}
                            </td>
                            <td className="text-center">
                                {currencyInputField(row, "paid", setIsSavedResult, editable, certificate, setCertificate, showAccount, updateTotalBalance)}
                            </td>
                            <td className="text-center">
                                {currencyInputField(row, "currentMonth", setIsSavedResult, editable, certificate, setCertificate, showAccount, updateTotalBalance)}
                            </td>
                            <td className="text-center">
                                {currencyInputField(row, "nextMonth", setIsSavedResult, editable, certificate, setCertificate, showAccount, updateTotalBalance)}
                            </td>

                            <td className="text-center">
                                {selectDropDownField(
                                    row,
                                    "frequency",
                                    setIsSavedResult,
                                    enums?.["Frequency"],
                                    editable,
                                    certificate,
                                    setCertificate,
                                    showAccount,
                                    setUpdatedAccountIndexList
                                )}
                            </td>

                            <td className="text-center">
                                {noteTextAreaField(row, setIsSavedResult, editable, certificate, setCertificate, showAccount)}
                            </td>

                        </tr>
                    ))}
                    <tr className="bg-surface-5">
                        <td/>
                        <td>
                            <b>Total Balance :</b>
                        </td>
                        <td/>
                        <td/>
                        <td className="text-center pl-4">
                            <NumberFormat
                                placeholder="..."
                                className="border-0   outline-none bg-surface-5"
                                decimalScale={
                                    curAccount?.["amountTotal"] !== null ? 2 : undefined
                                }
                                decimalSeparator="."
                                fixedDecimalScale
                                isNumericString={
                                    curAccount?.["amountTotal"] !== null &&
                                    curAccount?.["amountTotal"] !== undefined
                                }
                                value={formatValue(curAccount?.["amountTotal"])}
                                prefix={curAccount?.["amountTotal"] !== null ? "$" : ""}
                                thousandSeparator={true}
                                readOnly
                            />
                        </td>
                        <td className="text-center pl-4">
                            <NumberFormat
                                placeholder="..."
                                className="border-0 outline-none  bg-surface-5"
                                decimalScale={
                                    curAccount?.["paidTotal"] !== null ? 2 : undefined
                                }
                                decimalSeparator="."
                                fixedDecimalScale
                                isNumericString={
                                    curAccount?.["paidTotal"] !== null &&
                                    curAccount?.["paidTotal"] !== undefined
                                }
                                value={formatValue(curAccount?.["paidTotal"])}
                                prefix={curAccount?.["paidTotal"] !== null ? "$" : ""}
                                thousandSeparator={true}
                                readOnly
                            />
                        </td>
                        <td className="text-center pl-4">
                            <NumberFormat
                                placeholder="..."
                                className="border-0  outline-none bg-surface-5"
                                decimalScale={
                                    curAccount?.["currentMonthTotal"] !== null ? 2 : undefined
                                }
                                decimalSeparator="."
                                fixedDecimalScale
                                isNumericString={
                                    curAccount?.["currentMonthTotal"] !== null &&
                                    curAccount?.["currentMonthTotal"] !== undefined
                                }
                                value={formatValue(curAccount?.["currentMonthTotal"])}
                                prefix={curAccount?.["currentMonthTotal"] !== null ? "$" : ""}
                                thousandSeparator={true}
                                readOnly
                            />
                        </td>
                        <td className="text-center pl-4">
                            <NumberFormat
                                placeholder="..."
                                className="border-0  outline-none bg-surface-5"
                                decimalScale={
                                    curAccount?.["nextMonthTotal"] !== null ? 2 : undefined
                                }
                                decimalSeparator="."
                                fixedDecimalScale
                                isNumericString={
                                    curAccount?.["nextMonthTotal"] !== null &&
                                    curAccount?.["nextMonthTotal"] !== undefined
                                }
                                value={formatValue(curAccount?.["nextMonthTotal"])}
                                prefix={curAccount?.["nextMonthTotal"] !== null ? "$" : ""}
                                thousandSeparator={true}
                                readOnly
                            />
                        </td>
                        <td/>
                        <td/>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}